module.exports = __webpack_public_path__ + "assets/img/coupon-exchanged.96a04d26.png";